import React, { Component } from 'react'
import { ContainerLimit } from './limit.style'

class Limit extends Component {
	constructor(props) {
		super(props)
	}

	render() {
		const {
			percent,
			limitValue,
			cardStatus,
			closingDate,
			invoiceExists,
			originalLimitValue
		} = this.props

		var zeroValue = 0
		var limit = originalLimitValue - limitValue && originalLimitValue - limitValue >= 0
			? Number(originalLimitValue - limitValue) : 0;

		return (
			<ContainerLimit>
				<div className="box-limit">
					<p>Limite utilizado</p>
					<p>Disponível</p>
				</div>
				<div className="box-range">
					<div className="range" style={{ width: `${percent}%` }}></div>
				</div>
				<div className="box-limit">
					<p>
						{limit.$toReais()}

					</p>
					<p>{limitValue ? Number(limitValue).$toReais() : zeroValue.$toReais()}</p>
				</div>

				{invoiceExists ? (
					<div className="box-limit">
						<p>
							Melhor dia de compra:{' '}
							{closingDate.substring(0, 2)}
						</p>
					</div>
				) : null}
				<div className="box-limit">
					<p><strong>MUVICARD {cardStatus.toUpperCase()}</strong></p>
				</div>
			</ContainerLimit>
		)
	}
}

export default Limit
